// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__GmOdK","productName":"Table_productName__jnp2u"};